const Kategoriya2412 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 4-chorak<br />
                Mavzu: Eng yaxshi ixtirolar<br />
“Oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Juftlikda ishlang. Quyidagi iboralar mazmunini yozing.  </b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning gap  haqidagi ko‘nikmalarini rivojlantirish.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            <p className="text-break">Ko‘ngli taskin topmoq
________________________________________________________________
</p>
<p className="text-break">Eti suyagiga yopishgan
________________________________________________________________
</p>
            <p><b>2-mashq. Quyidagi iboralarni bir so‘z bilan ifodalang.</b></p>
            <p><i>Ta'limiy maqsad:</i>O‘quvchilarning leksik ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa</p>
            <p>Tepsa tebranmas - __________________</p>
            <p>Og‘zi qulog‘ida - ___________________</p>
            <p><b>3-mashq. FDM usulidan foydalanib, quyidagi maqolni izohlang.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Birlashgan o‘zar, birlashmagan to‘zar.</p>
            <p className="text-break">Fikr - ___________________________________________________________</p>
            <p className="text-break">Dalil - __________________________________________________________</p>
            <p className="text-break">Misol - _______________________________________________________</p>
        </div>
    )
}
export default Kategoriya2412;